import {
    DateRangePickerProps,
} from '@amzn/awsui-components-react';

export const isValidRange = (range: DateRangePickerProps.Value | null): DateRangePickerProps.ValidationResult => {
    if (!range) {
        return {
            valid: false,
            errorMessage: 'Please select a date range'
        };
    }

    if (range.type === 'absolute') {
        const [startDateWithoutTime] = range.startDate?.split('T') || [];
        const [endDateWithoutTime] = range.endDate?.split('T') || [];

        if (!startDateWithoutTime || !endDateWithoutTime) {
            return {
                valid: false,
                errorMessage: 'The selected date range is incomplete. Select a start and end date for the date range.'
            };
        }

        if (new Date(range.startDate) > new Date(range.endDate)) {
            return {
                valid: false,
                errorMessage: 'The selected date range is invalid. The start date must be before the end date.'
            };
        }
    }

    return { valid: true };
};

export const datePickerI18nStrings: DateRangePickerProps.I18nStrings = {
    todayAriaLabel: 'Today',
    nextMonthAriaLabel: 'Next month',
    previousMonthAriaLabel: 'Previous month',
    customRelativeRangeDurationLabel: 'Duration',
    customRelativeRangeDurationPlaceholder: 'Enter duration',
    customRelativeRangeOptionLabel: 'Custom range',
    customRelativeRangeOptionDescription: 'Set a custom range in the past',
    customRelativeRangeUnitLabel: 'Unit',
    formatRelativeRange: (e) => `Last ${e.amount} ${e.unit}${e.amount === 1 ? '' : 's'}`,
    formatUnit: (unit, value) => `${unit}${value === 1 ? '' : 's'}`,
    dateTimeConstraintText: 'Range must be between 1 and 180 days',
    relativeModeTitle: 'Relative range',
    absoluteModeTitle: 'Absolute range',
    relativeRangeSelectionHeading: 'Choose a range',
    startDateLabel: 'Start date',
    endDateLabel: 'End date',
    clearButtonLabel: 'Clear',
    cancelButtonLabel: 'Cancel',
    applyButtonLabel: 'Apply'
};

export const relativeDateOptions: DateRangePickerProps.RelativeOption[] = [
    {
        key: 'last 7 days',
        amount: 7,
        unit: 'day',
        type: 'relative'
    },
    {
        key: 'last 30 days',
        amount: 30,
        unit: 'day',
        type: 'relative'
    },
    {
        key: 'last 3 months',
        amount: 3,
        unit: 'month',
        type: 'relative'
    },
    {
        key: 'last 6 months',
        amount: 6,
        unit: 'month',
        type: 'relative'
    }
];